export default {
  cancelled: 'Cancelado',
  pending: 'Pendiente',
  waiting: 'Aceptado',
  preparing: 'En cocina',
  delivering: 'En despacho',
  done: 'Completado'
}
